<template>
  <div class="continer">
    <ul>
      <li>
        <span>公正</span>
        <span>求实</span>
        <span>博学</span>
        <span>严谨</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="stylus" scoped>
.continer 
  width 100%
  color #333
  li 
    text-align center
    span 
      display inline-block
      font-size 36px
      margin 0 10px
</style>
